import DataAPI from "./Access";
const endpoint = "/API/Portfolio";

export default {
    Read: {
        ProjectDateRange: async function() {
            return await DataAPI.get(`${endpoint}/Read/ProjectDateRange`);
        },
        ProjectByProjectID: async function(projectID) {
            return await DataAPI.get(`${endpoint}/Read/ProjectByProjectID/${projectID}`);
        },
        ProjectListByCategory: async function() {
            return await DataAPI.get(`${endpoint}/Read/ProjectListByCategory`);
        },
        TimelineData: async function() {
            return await DataAPI.get(`${endpoint}/Read/ProjectTimelineData`);
        },
        Counts: async function() {
            return await DataAPI.get(`${endpoint}/Read/Counts`);
        },
        DistinctTypes: async function() {
            return await DataAPI.get(`${endpoint}/Read/DistinctTypes`);
        },
        ProjectTypes: async function() {
            return await DataAPI.get(`${endpoint}/Read/ProjectTypes`);
        },
        AnalysisUsageProfile: async function() {
            return await DataAPI.get(`${endpoint}/Read/AnalysisUsageProfile`);
        },
        Accolades: async function() {
            return await DataAPI.get(`${endpoint}/Read/Accolades`);
        },
        AccoladeByAccoladeID: async function(accoladeID) {
            return await DataAPI.get(`${endpoint}/Read/Accolade/${accoladeID}`);
        }
    }
};